import { render, staticRenderFns } from "./GameAssetsDataTable.vue?vue&type=template&id=54d55886&scoped=true"
import script from "./GameAssetsDataTable.vue?vue&type=script&lang=js"
export * from "./GameAssetsDataTable.vue?vue&type=script&lang=js"
import style0 from "./GameAssetsDataTable.vue?vue&type=style&index=0&id=54d55886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d55886",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QInput,QIcon,QTd,QBtn});
